// extracted by mini-css-extract-plugin
export default {"linkPadding":"xltvIVpEk1NzotCmyD2fjg=="};